const STORAGE_KEY = 'library_pinned_playlists'
const CHANGE_EVENT = 'library-pinned-playlists-changed'

function normalizeId(id) {
    return id === undefined || id === null ? '' : String(id)
}

export function getPinnedPlaylistIds() {
    try {
        const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
        return Array.isArray(value) ? value.map(normalizeId).filter(Boolean) : []
    } catch (error) {
        return []
    }
}

export function isPlaylistPinned(id) {
    return getPinnedPlaylistIds().includes(normalizeId(id))
}

export function setPlaylistPinned(id, pinned) {
    const playlistId = normalizeId(id)
    if (!playlistId) {
        return []
    }
    const ids = getPinnedPlaylistIds().filter(item => item !== playlistId)
    if (pinned) {
        ids.unshift(playlistId)
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids))
    window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: ids }))
    return ids
}

export function togglePlaylistPinned(id) {
    const pinned = !isPlaylistPinned(id)
    setPlaylistPinned(id, pinned)
    return pinned
}

export { CHANGE_EVENT as PINNED_PLAYLISTS_CHANGE_EVENT }
